(function () {
  var loader = document.currentScript;
  var swiperCssSrc = loader.dataset.swiperCssSrc;
  var swiperScriptSrc = loader.dataset.swiperScriptSrc;

  function loadSwiperIfNeeded() {
    if (window.swiperLoading || window.swiperLoaded) return;
    if (!document.querySelector('.swiper')) return;
    window.swiperLoading = true;

    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = swiperCssSrc;
    document.head.appendChild(css);

    var script = document.createElement('script');
    script.src = swiperScriptSrc;
    script.onload = function () {
      window.swiperLoaded = true;
      window.dispatchEvent(new Event('swiper:ready'));
    };
    document.head.appendChild(script);
  }

  // Content injected later (e.g. the cart drawer's free gift slider, added
  // via AJAX after the cart starts empty) can introduce the first `.swiper`
  // on the page after this initial check, so expose it for re-checking.
  window.RasasiLoadSwiper = loadSwiperIfNeeded;

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (event.target.closest('.swiper, [class*="-prev"], [class*="-next"]')) loadSwiperIfNeeded();
    },
    { passive: true, capture: true }
  );

  if (document.readyState === 'complete') {
    loadSwiperIfNeeded();
  } else {
    window.addEventListener('load', loadSwiperIfNeeded, { once: true });
  }
})();
